import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as fromStore from './store';
import { environment, EnvironmentEnum } from '../environments';

export function httpLoaderFactory(httpClient: HttpClient) {
  const suffix =
    environment.env !== EnvironmentEnum.localdev
      ? `_${environment.version.split('.').join('_')}`
      : '';

  // translation files are renamed with version suffix for [ integration, qa, staging, rc, prod ] envs during jenkins deployment
  return new TranslateHttpLoader(httpClient, 'assets/i18n/', `${suffix}.json`);
}

export const TRANSLATE_LOADER = {
  loader: {
    provide: TranslateLoader,
    useFactory: httpLoaderFactory,
    deps: [HttpClient],
  },
};

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([...fromStore.effects]),
    StoreModule.forFeature(
      fromStore.FEATURE_NAME,
      fromStore.localizationReducer
    ),
  ],
})
export class LocalizationModule {
  static forRoot(): ModuleWithProviders<LocalizationModule> {
    return {
      ngModule: LocalizationModule,
      providers: [...fromStore.services],
    };
  }
}
